import { ApiService } from '@App/app/shared/api.service';
import { Injectable } from '@angular/core';
import { IPresetModel } from '@App/app/entities/processing/processing-preset-settings.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProcessingPresetsHttpService extends ApiService {
  getBuildProcessPresets(): Observable<IPresetModel[]> {
    return this.http.get<IPresetModel[]>(`${this.api}/processing-presets`);
  }
}
